import React, { FC } from 'react';

import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../../../hooks';
import styles from './CreateFolderButton.module.scss';

const nameSpace = 'myFiles.header.buttons';

/**
 * Opens the existing Create Folder modal. The modal itself (and its
 * post-create refresh) is still owned by App; this button only toggles the
 * shared open-state on AppStore so the control can live next to the
 * Add Files / Add Folders buttons in the My Files header.
 */
const CreateFolderButton: FC = observer(() => {
    const { t } = useTranslation();
    const { appStore } = useStores();

    return (
        <Button
            data-testid="myFilesHeader_createFolderButton"
            className={styles['open-button']}
            icon={<PlusOutlined className={styles.icon} />}
            onClick={appStore.openCreateFolder}
        >
            {t(`${nameSpace}.createFolder`)}
        </Button>
    );
});

export default CreateFolderButton;
